<template>
  <div id="app">
    <FrkGtmTracking />
    <FrkVersionUpgrader />
    <UserNotificationsContainer />
    <UserTermsModal />
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

import FrkVersionUpgrader from '@/components/FrkVersionUpgrader.vue';
import UserNotificationsContainer from '@/domain/user/components/UserNotificationsContainer.vue';

import FrkGtmTracking from './components/FrkGtmTracking.vue';
import UserTermsModal from './components/UserTermsModal.vue';

import { buildMetaInfo } from '../helpers';
import { ENV } from '../env';

const { pathname } = window.location;
const canonicalUrl = `${ENV.BASE_URL}${pathname}`;

const metaInfo = buildMetaInfo({
  title: 'Plateforme de freelances informatiques',
  description:
    'La plateforme FreelanceRepublik sélectionne et vous propose les freelances tech les plus qualifiés pour mener à bien vos missions.',
  socialImage: 'https://s3.eu-west-3.amazonaws.com/frk-production/publicFiles/og-image.png?v=1',
  link: [{ rel: 'canonical', href: canonicalUrl }],
  meta: [
    { name: 'og:site_name', content: 'FreelanceRepublik' },
    { name: 'og:type', content: 'website' },
    { name: 'og:url', content: 'https://app.freelancerepublik.com' },
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:site', content: '@Freelance_Talks' },
  ],
});

useHead({
  title: metaInfo.title,
  titleTemplate: titleChunk => (titleChunk ? `${titleChunk} - FreelanceRepublik` : 'FreelanceRepublik'),
  meta: metaInfo.meta,
  link: metaInfo.link,
});
</script>

<style src="../assets/styles/index.scss" lang="scss"></style>
